import { render, staticRenderFns } from "./TheRadarMonthBadge.vue?vue&type=template&id=78af20c5&scoped=true&"
import script from "./TheRadarMonthBadge.vue?vue&type=script&lang=js&"
export * from "./TheRadarMonthBadge.vue?vue&type=script&lang=js&"
import style0 from "./TheRadarMonthBadge.vue?vue&type=style&index=0&id=78af20c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78af20c5",
  null
  
)

export default component.exports